/** Get browser language. */
export function getBrowserLanguage(): string {
    return navigator.language.split('-')[0].toLowerCase();
}


/** Get browser language with region.  */
export function getBrowserLocaleWithRegion(): string {
    for (const locale of navigator.languages) {
        if (locale.includes('-')) {
            return locale;
        }
    }
    return '';
}


/** Get browser country code. */
export function getBrowserCountryCode(): string {
    return getBrowserLocaleWithRegion().split('-').at(1) || '';
}
